import { useIonToast } from '@ionic/react';
import { useEffect, useState } from 'react'
import { ApiErrorResponse } from '../_network/response';
import { CompanyApi } from '../_services/company-api';
import { Company } from '../_services/company-api/params';
import { UnknownError } from '../_network/response';

function useCurrentCompany() :[Company | undefined, ApiErrorResponse | undefined, ()=>{}] {
    const [toast] = useIonToast();
    const [result, setResult] = useState<Company>();
    const [error, setError] = useState<ApiErrorResponse>();
    
    async function mutate() {
      fetch()
    }
  
    async function fetch() {
      try {
        var res = await CompanyApi.GetCurrent();
        setResult(res.data);
      } catch (error) {
        if(error as ApiErrorResponse){
            toast({ message: (error as ApiErrorResponse).message, duration: 1500, position: "top", color: "danger", cssClass: "max-w-[480px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" })
            setError((error as ApiErrorResponse));
        } else {
            console.log("Unknown error:", error);
            toast({ message: "Internal Error", duration: 1500, position: "top", color: "danger" })
            setError(UnknownError(""));
        }
      } finally {
      }
    }
    
    useEffect(() => {
        fetch()
    }, [])
  
    return [result, error, mutate];
}

export default useCurrentCompany